__turbopack_context__.v({
  "container": "AccordionMenu-module-scss-module__xdxvFq__container",
});
